































































import { Vue, Component, Watch, Prop } from "vue-property-decorator";
import { UsersList as IUsersList } from "@/api/models/users-list";
import { UsersListParams } from "@/getinfo-api/users";
import { User as IUser } from "@/api/models/user";
import { uniqBy } from "lodash";
import userList from "@/getinfo-api/users";
import CustomTable from "@/components/form/CustomTable.vue";
import SearchUserItem from "@/components/user/SearchUserItem.vue";
import CField from "@/components/form/CField.vue";
import { hideListeners } from "@/plugins/modules-detect";

@Component({
  components: { CField, SearchUserItem, CustomTable }
})
export default class SearchUser extends Vue {
  @Prop() searchField?: string;
  @Prop({ default: () => [] }) addedUsersIds?: Array<string>;
  usersWithOffset: Array<IUser> = [];
  usersCount: number = 0;
  search!: string | undefined;
  processing: boolean = false;
  registeredAtMin!: Date;
  registeredAtMax!: Date;

  data() {
    return {
      search: undefined,
      registeredAtMin: undefined,
      registeredAtMax: undefined
    };
  }

  entityHandler(item: IUser) {
    this.$emit("entity", item);
  }

  getFirstUsers() {
    this.usersWithOffset = [];
    let params: UsersListParams = {
      limit: 30,
      registeredAtMin: this.registeredAtMin,
      registeredAtMax: this.registeredAtMax,
      sort: "registeredAt",
      order: "DESC"
    };
    this.processing = true;
    userList(params)
      .then((res: { data: IUsersList }) => {
        if (res.data.users && res.data.users.length) {
          this.usersWithOffset = res.data.users;
        }
      })
      .finally(() => {
        this.processing = false;
      });
  }

  @Watch("searchField")
  checkPropSearch() {
    this.search = this.searchField ? this.searchField : this.search;
  }

  searchUsersByParams() {
    this.usersWithOffset = [];
    let params: UsersListParams = {
      searchField: this.search,
      registeredAtMin: this.registeredAtMin,
      registeredAtMax: this.registeredAtMax
        ? new Date(this.registeredAtMax.setHours(23, 59))
        : undefined,
      limit: 30,
      sort: "registeredAt",
      order: "DESC"
    };
    userList(params)
      .then((res: { data: IUsersList }) => {
        if (res.data.users && res.data.users.length > 0) {
          res.data.users.forEach(item => {
            this.usersWithOffset.push(item);
          });
          this.usersWithOffset = uniqBy(this.usersWithOffset, "id");
        }
      })
      .finally(() => {
        this.processing = false;
      });
  }

  get isHideListeners() {
    return hideListeners();
  }

  @Watch("registeredAtMin")
  checkRegAtMin() {
    if (this.isHideListeners && this.allFieldsEmpty) {
      this.usersWithOffset = [];
    } else {
      this.processing = true;
      this.searchUsersByParams();
    }
  }

  @Watch("registeredAtMax")
  checkRegAtMax() {
    if (this.isHideListeners && this.allFieldsEmpty) {
      this.usersWithOffset = [];
    } else {
      this.processing = true;
      this.searchUsersByParams();
    }
  }

  @Watch("search")
  checkSearch() {
    if (this.isHideListeners && this.allFieldsEmpty) {
      this.usersWithOffset = [];
    } else if (this.search && this.search.length > 2) {
      this.processing = true;
      this.searchUsersByParams();
    } else if (this.search === "") {
      this.getFirstUsers();
    }
  }

  get allFieldsEmpty() {
    return !this.search && !this.registeredAtMax && !this.registeredAtMin;
  }

  created() {
    !this.isHideListeners ? this.getFirstUsers() : null;
  }
}
